<script lang="ts">
	import { parseInlineBoldSegments } from '../parse-inline-bold-segments';

	export let text = '';
</script>

{#each parseInlineBoldSegments(text) as seg, i (i)}
	{#if seg.bold}
		<strong class="bubble-inline-strong">{seg.text}</strong>
	{:else}
		{seg.text}
	{/if}
{/each}

<style>
	.bubble-inline-strong {
		font-weight: 600;
	}
</style>
